import React, { useState } from "react";
import { IFeedbackQuestion } from "../feedback.type";
import { feedbackStyle } from "../style";
import {
	ChefHatIcon,
	HappyIcon,
	HearthIcon,
	HearthIconFilled,
	NeutralSmileIcon,
	SadIcon,
	StarIcon,
	StarIconFilled,
	ThumbUpIcon,
	ThumbUpIconFilled,
} from "../../customIcons";

export const RatingFeedbackQuestion: React.FC<IFeedbackQuestion> = (props) => {
	const [rating, setRating] = useState(0);
	const [disabled, setDisabled] = useState(false);
	const { question } = props;
	const classes = feedbackStyle();

	if (!question || question.type !== "rating") {
		return null;
	}

	const containerClasses = [
		classes.scaleContainer,
		disabled ? classes.disabled : "",
	];

	const values = Array.from(
		{ length: question.config.max },
		(_, i) => i + 1
	).slice(0, question.config.max);

	const handleChange = (value: number) => {
		if (value === rating) {
			return;
		}
		setRating(value);
		if (props.onChange) {
			props.onChange(question.id, `${value}`);
		}
		setDisabled(true);
		setTimeout(() => {
			setDisabled(false);
		}, 800);
	};

	let EmptyIcon;
	let FullIcon;

	switch (question.config.icon) {
		case "heart":
			EmptyIcon = HearthIcon;
			FullIcon = HearthIconFilled;
			break;
		case "smile":
			return (
				<div className={containerClasses.join(" ")}>
					{values.map((value, index) => {
						let Icon: any = NeutralSmileIcon;
						if (
							values.length === value ||
							(values.length - 1 === value && values.length > 4)
						) {
							Icon = HappyIcon;
						} else if (
							value === 1 ||
							(value === 2 && values.length > 4)
						) {
							Icon = SadIcon;
						} else {
							Icon = NeutralSmileIcon;
						}

						return (
							<div
								onClick={() => handleChange(value)}
								key={`${question.commonId}-${index}`}
							>
								{rating >= value ? (
									<Icon
										className={`${classes.star} ${classes.starActive}`}
									/>
								) : (
									<Icon className={classes.star} />
								)}
							</div>
						);
					})}
				</div>
			);
		case "thumb":
			EmptyIcon = ThumbUpIcon;
			FullIcon = ThumbUpIconFilled;
			break;
		case "chef":
			EmptyIcon = ChefHatIcon;
			FullIcon = ChefHatIcon;
			break;
		case "star":
		default:
			EmptyIcon = StarIcon;
			FullIcon = StarIconFilled;
			break;
	}

	return (
		<div className={containerClasses.join(" ")}>
			{values.map((value, index) => {
				return (
					<div
						onClick={() => handleChange(value)}
						key={`${question.commonId}-${index}`}
					>
						{rating >= value ? (
							<FullIcon
								className={`${classes.star} ${classes.starActive}`}
							/>
						) : (
							<EmptyIcon className={classes.star} />
						)}
					</div>
				);
			})}
		</div>
	);
};
